import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import NobulaLogoIcon from '../../../../assets/icons/NobulaLogo.svg';
import {loggedInUserSelector} from '../../../store/selectors/auth.selector';
import ConnectionStatus from '../ConnectionStatus';
import {loadedPresentationSelector} from '../../../store/selectors/presentation.selectors';
import LeaderBoard from '../../../components/widget/Leaderboard';
import {openEndPresentationAction} from '../../../store/actions/chalkBoardElements.actions';
import Profile from '../../../components/widget/Profile';
import Timer from '../../../components/widget/timer';
import ToggleMobileView from '../../../components/widget/ToggleMobileView';
import {usePresentationMode} from '../../../hooks/usePresentationMode';
import {connectionStatusSelector} from '../../../store/selectors/connectionStatus.selector';
import LanguageSelectorDropdown from '../../../components/widget/LanguageSelectorDropdown';
import FileImport from '../../../components/widget/FileImport';
import Button from '../../../incase-domain/components/button/Button';
import MenuBar from '../../../components/widget/menubar/MenuBar';
import {pointsSelector} from '../../../store/selectors/runfile.selectors';

interface HeaderProps {
    presContainerRef: React.RefObject<HTMLDivElement>;
    hasPresActions?: boolean;
}

function Header({presContainerRef, hasPresActions = false}: HeaderProps): JSX.Element {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const points = useSelector(pointsSelector);
    const loggedInUser = useSelector(loggedInUserSelector);
    const presentation = useSelector(loadedPresentationSelector);
    const {showViewerCount, viewerCount, showLeaderboard} = usePresentationMode();
    const connectionStatus = useSelector(connectionStatusSelector);

    return (
        <div className="c-headerWrapper">
            <header className="c-header">
                <div className="c-header__group">
                    <Button variant="ghost" size="xl" square onClick={() => dispatch(openEndPresentationAction())}>
                        <img src={NobulaLogoIcon} alt="" />
                    </Button>
                    <div>
                        {presentation ? (
                            <div className="c-header__group_title">{presentation?.name}</div>
                        ) : (
                            <div className="c-header__group_appName">Nobula Case Player</div>
                        )}
                        {hasPresActions && presentation && (
                            <>
                                {!connectionStatus.hidden && (
                                    <div className="c-header__group_icon">
                                        <ConnectionStatus type={connectionStatus.type} message={connectionStatus.message} />
                                    </div>
                                )}
                                <MenuBar presContainerRef={presContainerRef} />
                            </>
                        )}
                    </div>
                </div>

                {hasPresActions && presentation && (
                    <div className="c-header__group">
                        <Button variant="ghost" size="lg" leading="solar:clock-circle-linear" disablePointerEvents>
                            <Timer />
                        </Button>
                        {showViewerCount && (
                            <Button leading="solar:users-group-rounded-linear" size="lg" variant="ghost" disablePointerEvents>
                                {t('header.viewers', {count: viewerCount})}
                            </Button>
                        )}
                        <Button leading="solar:cup-outline" variant="ghost" size="lg" disablePointerEvents>
                            {t('header.points', {count: points})}
                        </Button>
                        <div className="c-header__group_icon">
                            <ToggleMobileView />
                        </div>
                    </div>
                )}

                <div className="c-header__group">
                    {/* <div className="c-header__group_icon">
                        <IconButton icon="fa:question-circle" label={t('header.help')} />
                    </div> */}
                    {!presentation && <FileImport />}

                    <LanguageSelectorDropdown />
                    {hasPresActions && presentation && showLeaderboard && <LeaderBoard />}
                    {loggedInUser && <Profile />}

                    <div className="u-ml-1" />
                    {hasPresActions && presentation && (
                        <>
                            <Button
                                leading="ph:x"
                                size="md"
                                variant="solid"
                                onClick={() => dispatch(openEndPresentationAction())}
                                dataCy="exit_presentation"
                            >
                                {t('header.exit')}
                            </Button>
                        </>
                    )}
                </div>
            </header>
        </div>
    );
}

export default Header;
